import { Button } from "@/components/shadcn/button";
import { LoadingButton } from "../../components/ui/Button";
import { TextInput } from "../../components/ui/form/TextInput";
import { useNavigate } from "@solidjs/router";
import useRecoverPassword from "../../services/auth/useRecoverPassword";

export default function RecoverPassword() {
  const { form, onFormInput, onRecoverPassword, onSubmit, loading } = useRecoverPassword();
  const navigate = useNavigate();

  const navigateToLoginPage = () => {
    navigate("/auth/login", { replace: true });
  }

  return (
    <div class="space-y-6">
      <div class="flex flex-col space-y-2 text-center">
        <h1 class="text-2xl font-semibold tracking-tight">
          Recover Password
        </h1>
        <p class="text-sm text-muted-foreground">
          After requesting new password, Check your email for new password.
        </p>
      </div>
      <div class="grid gap-6">
        <form onSubmit={onSubmit}>
          <div class="grid gap-2">
            <div class="grid gap-1">
              <TextInput
                type="email"
                name="email"
                form={form}
                loading={loading()}
                sr={true}
                input={onFormInput}
                label='Email'
                placeholder="Email" />
            </div>
            <div class="grid gap-1">
              <TextInput
                type="text"
                name="code"
                form={form}
                loading={loading()}
                sr={true}
                input={onFormInput}
                label='Recovery Code'
                placeholder="Recovery Code" />
            </div>
            <div class="grid gap-1 mt-[5px]">
              <LoadingButton onClick={(e) => { onRecoverPassword() }} loading={loading()}>Request New Password</LoadingButton>
            </div>
          </div>
        </form>
        <div class="inset-0 flex items-center">
          <span class="w-full border-t" />
        </div>
        <Button variant="outline" onClick={() => { navigateToLoginPage() }} type="button" disabled={loading()}>
          Goto Login Page
        </Button>
      </div>
    </div>
  );

}
